import { TextControl } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import type { CommonFieldProps } from '../types';

export type URLProps = CommonFieldProps<
  string,
  HTMLInputElement | HTMLTextAreaElement
>;

export const URL = ({
  label,
  showLabel = true,
  onChange,
  fieldFontStyle,
  fieldLabelPosition,
  fieldLabelColor,
  fieldLabelFontStyle,
  fieldColor,
  fieldFillColor,
  fieldBorderType,
  fieldBorderColor,
  fieldBorderWidth,
  fieldBorderRadius,
  ...forwardingProps
}: URLProps) => {
  return (
    <TextControl
      {...forwardingProps}
      className={createReadableClass({
        component: 'fields',
        element: 'url'
      })}
      type="text"
      label={showLabel && fieldLabelPosition === 'inside' ? label : undefined}
      labelFont={fieldLabelFontStyle}
      labelColor={fieldLabelColor}
      color={fieldColor}
      background={fieldFillColor}
      font={fieldFontStyle}
      borderType={fieldBorderType ? fieldBorderType : undefined}
      borderColor={fieldBorderColor}
      borderWidth={fieldBorderWidth}
      borderRadius={fieldBorderRadius}
      onValueChange={onChange}
    />
  );
};
